<template>
	<div>
		<div class="d-none d-sm-block mx-2">
			<div v-show="updateExists">
				<a-tooltip placement="bottom">
					<template slot="title">
						<span>
							🌎 Actualización disponible
						</span>
					</template>
					<a @click="refreshApp">
						<a-icon
							type="cloud-download"
							class="animate__animated animate__infinite animate__pulse text-success"
							style="font-size: 28px"
						/>
					</a>
				</a-tooltip>
			</div>

			<div v-show="refreshing">
				<a-icon
					type="loading"
					spin
					class="text-primary"
				/>
			</div>
		</div>

		<div
			v-if="updateExists || refreshing"
			class="d-flex d-sm-none"
			:class="[$style.snack, snackClass]"
		>
			<div v-show="updateExists">
				<span
					class="
						animate__animated
						animate__shakeX
						animate__delay-2s
					"
				>🎉 Nueva versión! </span>
				<div class="mr-auto" />
				<a-button
					type="link"
					class="text-success text-uppercase font-weight-bold"
					@click="refreshApp"
				>
					Actualizar
				</a-button>
			</div>
			<div v-show="refreshing">
				🚧 Actualizando...
				<div class="mr-auto" />
				<a-icon type="loading" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'UpdateCheck',
	data() {
		return {
			registration: null,
			updateExists: false,
			refreshing: false
		};
	},
	computed: {
		snackClass() {
			if (this.updateExists || this.refreshing) {
				return 'animate__animated animate__slideInUp';
			}

			return 'animate__animated animate__slideOutDown';
		}
	},
	created() {
		document.addEventListener('swUpdated', this.showRefreshUI, { once: true });

		navigator.serviceWorker.addEventListener('controllerchange', () => {
			if (this.refreshing) return;
			this.refreshing = true;
			this.$gestios.$cache.clean();
			window.location.reload(true);
		});
	},
	methods: {
		showRefreshUI(e) {
			this.registration = e.detail;
			this.updateExists = true;
		},
		refreshApp() {
			this.updateExists = false;

			if (!this.registration || !this.registration.waiting) { return; }
			this.registration.waiting.postMessage('skipWaiting');
		},
		toggle() {
			if (this.updateExists === true) {
				this.updateExists = false;
				this.refreshing = true;
			} else {
				this.updateExists = true;
				this.refreshing = false;
			}
		},
		endd() {
			this.updateExists = false;
			this.refreshing = false;
		}
	}
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
